<template>
  <div class="-mt-5">
    <el-row>
      <el-col :span="24">
        <slot></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
  },
}
</script>

<style></style>
